<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Fees Receipts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Fees Receipts",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "student",
          label: "Student",
          sortable: true,
        },
        {
          key: "class",
          label: "Class",
          sortable: true,
        },
        {
          key: "term1",
          label: "Term",
          sortable: true,
        },
        {
          key: "year",
          label: "Year",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "pdate",
          label: "Payment Date",
          sortable: true,
        },
        {
          key: "mode",
          label: "Payment Mode",
          sortable: true,
        },
        {
          key: "actions",
          label: "Action",
          sortable: false,
        },
      ],
      data: {
        from: "",
        to: moment(new Date()).format("YYYY-MM-DD"),
      },
      edit: {
        id: "",
        amount: "",
        sid: "",
      },
      delete: {
        id: "",
        sid: "",
      },
      amountError: "",
      fromError: "",
    };
  },
  computed: {
    ...mapGetters("fees", ["FeesReceipts", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.FeesReceipts ? this.FeesReceipts.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FeesReceipts ? this.FeesReceipts.length : 1;
  },
  methods: {
    ...mapActions({
      FetchReceipts: "fees/fetchFeesReceipts",
      // DeletePayment: "fees/deletePayment",
      // EditAmount: "fees/editAmtPaid",
      RequestReceipt: "fees/requestReceipt",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.FeesReceipts ? this.FeesReceipts.length : 1;
      this.currentPage = 1;
    },
    resetError() {
      this.fromError = "";
    },
    showEditModal(values) {
      this.edit.id = values.item.id;
      this.edit.amount = values.item.amount;
    },
    showDeleteModal(values) {
      this.delete.id = values.item.id;
    },

    addCommas() {
      this.edit.amount = this.thousandSeperator(this.edit.amount);
    },

    // editAmount(values) {
    //   this.modal_id = values;
    //   if (this.edit.amount == "") {
    //     this.amountError = "Please enter the amount paid";
    //     return;
    //   } else {
    //     this.amountError = "";
    //   }
    //   this.EditAmount(this.edit);
    //   this.resetError();
    //   this.closeModal(this.modal_id);
    //   this.Fetch_Receipts();
    // },
    // deletePayment(values) {
    //   this.modal_id = values;
    //   this.DeletePayment(this.delete);
    //   this.closeModal(this.modal_id);
    //   this.Fetch_Receipts();
    // },

    Fetch_Receipts() {
      if (this.data.from == "") {
        this.fromError = "Please choose start date";
        return;
      } else {
        this.fromError = "";
      }
      this.FetchReceipts(this.data);
    },
    printReceipt(receipt) {
      this.RequestReceipt({ receipt });
    },
    // redirect(value) {
    //   this.$router.push(`/fees/receipt/${btoa(value)}`);
    // },
    // redirect2(value) {
    //   this.$router.push(`/fees/breakdown/${btoa(value)}`);
    // },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_payments')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label"
                    >From <span class="required">*</span></label
                  >
                  <input type="date" class="form-control" v-model="data.from" />
                  <div v-if="fromError" class="text-danger">
                    <em>{{ fromError }}</em>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">
                    To <span class="required">*</span></label
                  >
                  <input type="date" class="form-control" v-model="data.to" />
                </div>
              </div>
              <div class="col-md-3 mt-3">
                <br />
                <button @click="Fetch_Receipts()" class="btn btn-primary">
                  <i class="fa fa-search"></i> Search
                </button>
              </div>
              <div class="col-md-3"></div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="FeesReceipts ? FeesReceipts : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <span
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('view_fees_payments')
                      )
                    "
                  >
                    <button
                      v-if="SaveStatus"
                      disabled
                      class="btn btn-sm btn-outline-secondary"
                    >
                      <b-spinner
                        variant="secondary"
                        small
                        label="Retrieving..."
                      ></b-spinner>
                      Retrieving...
                    </button>
                    <button
                      v-else
                      @click="printReceipt(data.item.receipt)"
                      class="btn btn-sm btn-outline-secondary"
                    >
                      <i class="fa fa-print"></i> Receipt Reprint
                    </button>
                  </span>
                  <!-- 
                    BOC
                      I commented out this to make sure no record is edited or deleted.
                      I did this because the paid amount is saved in j entries for accounting.
                      J_entries is a big table where editing will be difficult with time.
                      By Bryan 09.2024
                    EOC 
                  -->
                  <!-- <b-dropdown size="sm">
                    <template v-slot:button-content>
                      Action
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item>
                      <button
                        @click="redirect(data.item.id)"
                        class="text-success"
                        v-if="
                          getCurrentUser.permissions.find((item) =>
                            item.permission.includes('view_fees_payments')
                          )
                        "
                      >
                        <i class="fa fa-print"></i> Receipt Reprint
                      </button>
                      </b-dropdown-item>
                      <b-dropdown-item>
                      <button
                        @click="redirect2(data.item.id)"
                        class="text-info"
                        v-if="
                          getCurrentUser.permissions.find((item) =>
                            item.permission.includes('view_fees_payments')
                          )
                        "
                      >
                        <i class="fa fa-exchange"></i> Breakdown
                      </button>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <a
                        href="#"
                        v-b-modal.edit-payment-modal
                        @click="showEditModal(data)"
                        class="text-info"
                        v-if="
                          getCurrentUser.permissions.find((item) =>
                            item.permission.includes('edit_fees_payments')
                          )
                        "
                      >
                        <i class="fa fa-edit"></i> Edit Amount
                      </a>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <a
                        href="#"
                        v-b-modal.delete-payment-modal
                        @click="showDeleteModal(data)"
                        class="text-danger"
                        v-if="
                          getCurrentUser.permissions.find((item) =>
                            item.permission.includes('delete_fees_payments')
                          )
                        "
                      >
                        <i class="fa fa-trash"></i> Delete Payment
                      </a>
                    </b-dropdown-item>
                  </b-dropdown> -->
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- edit modal starts -->
      <b-modal
        id="edit-payment-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_fees_payments')
          )
        "
      >
        <template #modal-title>
          Edit Fees Payment of ({{ edit.amount }})</template
        >
        <div class="form-group mb-2">
          <label>Amount</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control"
              @input="resetError(), addCommas()"
              v-model="edit.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
          <small class="text-primary">Amount That was Paid</small>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-payment-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="editAmount('edit-payment-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete payment starts -->
      <b-modal
        id="delete-payment-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_fees_payments')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">Delete This Fees Payment</h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Are you sure you want to delete this fees payment ? Click confirm
              button to Proceed.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-payment-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger"
            @click="deletePayment('delete-payment-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
